import { IJsonQuery } from '../types/json-query';
import { IOffer } from '../types/offer';

export const getCommercialOwnerShieldVisible = (
  { isByCommercialOwner, isCommercialOwnershipVerified, coworkingOfferType }: IOffer,
  jsonQuery: IJsonQuery,
) =>
  isByCommercialOwner &&
  isCommercialOwnershipVerified &&
  !jsonQuery.is_by_commercial_owner?.value &&
  !coworkingOfferType;
